const collections = [
  { title: '新番速递', desc: '本周最新上架的漫画作品，第一时间追更热门新连载', icon: 'ri-flashlight-line' },
  { title: '完结佳作', desc: '已完结的高质量漫画全集，一口气看到结局不等待', icon: 'ri-check-double-line' },
  { title: '独家连载', desc: '酷漫屋独家收录的连载作品，别处找不到的精彩内容', icon: 'ri-star-line' },
  { title: '编辑力荐', desc: '编辑团队精心挑选的高品质漫画，每部都是不可错过的佳作', icon: 'ri-thumb-up-line' },
  { title: '读者最爱', desc: '根据读者阅读量和收藏数据筛选的最受欢迎作品合集', icon: 'ri-heart-line' },
  { title: '话题作品', desc: '社区内讨论度最高的热门漫画，大家都在看的话题之作', icon: 'ri-chat-3-line' },
  { title: '限时热门', desc: '近期阅读数据飙升最快的漫画作品，热度持续上涨中', icon: 'ri-fire-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            主题索引
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按不同维度整理的漫画合集入口，快速定位你想看的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {collections.map((c, i) => {
            const isAccent = i === 3 || i === 6;
            return (
              <a
                key={c.title}
                href="#index"
                className={`group p-5 rounded-lg border transition-colors cursor-pointer ${
                  isAccent
                    ? 'bg-accent-50 border-accent-200/70 hover:bg-accent-100/80'
                    : 'bg-background-100 border-background-200/70 hover:bg-background-200/60'
                }`}
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-full mb-3 ${
                  isAccent ? 'bg-accent-100 text-accent-600' : 'bg-primary-100 text-primary-500'
                }`}>
                  <i className={`${c.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-base text-foreground-950 mb-1.5">{c.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{c.desc}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}